var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ethers } from 'ethers';
export class BundlerRPClient {
    constructor(bundlerUrl, chainId) {
        this.bundlerUrl = bundlerUrl;
        this.chainId = chainId;
        this.userOpJsonRpcProvider = new ethers.providers.JsonRpcProvider(this.bundlerUrl, {
            name: 'Connected bundler network',
            chainId
        });
        this.initializing = this.validateChainId();
    }
    validateChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            // validate chainId is in sync with expected chainid
            const chain = yield this.userOpJsonRpcProvider.send('eth_chainId', []);
            const bundlerChain = parseInt(chain);
            if (bundlerChain !== this.chainId) {
                throw new Error(`bundler ${this.bundlerUrl} is on chainId ${bundlerChain}, but provider is on chainId ${this.chainId}`);
            }
        });
    }
    /**
     * send a UserOperation to the bundler
     * @param userOp1
     * @return userOpHash the id of this operation, for getUserOperationTransaction
     */
    getUserOpReceipt(userOpHash) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initializing;
            return yield this.userOpJsonRpcProvider
                .send('eth_getUserOperationReceipt', [userOpHash]);
        });
    }
}
